/**
 * Format các giá trị
 */
export default {
  /**
   * Ngày
   */
  Date: 'YYYY-MM-DD',

  /**
   * Hiển thị ngày
   */
  DisplayDate: 'DD/MM/YYYY',
};
